import React, { useState, useEffect, useRef } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const Procuration = () => {
  // Champs du formulaire
  const [name, setName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [birthPlace, setBirthPlace] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [signatureDate, setSignatureDate] = useState("");
  const [signatureCity, setSignatureCity] = useState("");
  const [city, setCity] = useState("");
  const [signatureData, setSignatureData] = useState(null);
  const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
  const [isExpanded, setIsExpanded] = useState(false);
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showDownloadPrompt, setShowDownloadPrompt] = useState(false);
  const [download, setDownload] = useState(false)
  
  const canvasRef = useRef(null);
  const fileInputRef = useRef(null);
  
  const [isDrawing, setIsDrawing] = useState(false);
  const ctxRef = useRef(null);

  // Gestion du fichier
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  // Déclenchement du clic sur l'input caché
  const handleClickFileInput = () => {
    fileInputRef.current.click();
  };

  // Gestion du dessin (signature) sur le canvas  
  const getRelativePosition = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    let x, y;

    if (e.touches && e.touches.length > 0) {
      x = e.touches[0].clientX - rect.left;
      y = e.touches[0].clientY - rect.top;
    } else {
      x = e.clientX - rect.left;
      y = e.clientY - rect.top;
    }
  
    x = x * (canvas.width / rect.width);
    y = y * (canvas.height / rect.height);
  
    x = Math.max(0, Math.min(x, canvas.width));
    y = Math.max(0, Math.min(y, canvas.height));
  
    return { x, y };
  };

  const startDrawing = (e) => {
    const { x, y } = getRelativePosition(e);
    setIsDrawing(true);
    setLastPos({ x, y });
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const { x, y } = getRelativePosition(e);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    
    ctx.beginPath();
    ctx.moveTo(lastPos.x, lastPos.y);
    ctx.lineTo(x, y);
    ctx.stroke();
    setLastPos({ x, y });
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    startDrawing(e);
  };

  const handleMouseMove = (e) => {
    if (isDrawing) draw(e);
  };

  const handleMouseUp = () => {
    stopDrawing();
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    startDrawing(e);
  };

  const handleTouchMove = (e) => {
    if (!isDrawing) return;
    draw(e);
  };

  const handleTouchEnd = () => {
    setIsDrawing(false);
    if (ctxRef.current) {
      ctxRef.current.beginPath();
    }
  };

  const expandCanvas = () => {
    const canvas = canvasRef.current;
    const currentSignature = canvas.toDataURL();
    setSignatureData(currentSignature);
    setIsExpanded(true);
 
    setTimeout(() => {
      const newCanvas = canvasRef.current;
      const newCtx = newCanvas.getContext("2d");
      if (signatureData) {
        const img = new Image();
        img.src = signatureData;
        img.onload = () => {
          newCtx.drawImage(img, 0, 0);
        };
      }
    }, 0);
  };

  const collapseCanvas = () => {
    setIsExpanded(false);
    if (signatureData) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = signatureData;
      img.onload = () => {
        ctx.drawImage(img, 0, 0);
      };
    }
  };

  const clearSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setSignatureData(null);
  };

  // Vérifie si le canvas est vide
  const isSignatureEmpty = () => {
    const canvas = canvasRef.current;
    const blankCanvas = document.createElement('canvas');
    blankCanvas.width = canvas.width;
    blankCanvas.height = canvas.height;
    return canvas.toDataURL() === blankCanvas.toDataURL();
  };

  // Génère le PDF et le télécharge (ou retourne la donnée base64)
  const handleSubmitPDF = () => {
    if (!name || !birthDate || !birthPlace || !address || !email || !phone || !signatureCity || !signatureDate || !city) {
      alert("Veuillez remplir tous les champs !");
      return null;
    }
  
    if (isSignatureEmpty()) {
      alert("Veuillez signer avant de soumettre !");
      return null;
    }
  
    const title = 'PROCURATION POUR LE RETRAIT D’ACTE';
    const text = `
    agissant en mon nom propre et en pleine capacité juridique. DÉCLARE
    DONNER POUVOIR par la présente à : Monsieur SINDRAYE Fabrice,
    représentant l’entreprise OCI EXPRESS, afin de procéder en mon nom
    et pour mon compte au retrait des documents nécessaires auprès
    de toutes les mairies et organismes concernés.
  
    Le mandataire est autorisé à accomplir toutes les démarches afférentes
    à cette demande.
  
    Cette procuration couvre la demande et la récupération de mes
    actes et ceux de mes ascendants directs (parents, grands-parents,
    arrière-grands-parents) et descendants directs, 
    pour compléter mon dossier OCI.`;
  
    const pdf = new jsPDF();
    pdf.setFontSize(15);
    pdf.text(title, 50, 13);
    pdf.setFontSize(12);
    pdf.text(`Je soussigné(e), ${name}`, 20, 29, { fontSize: '5' });
    pdf.text(`né(e) le ${birthDate}`, 20, 39);
    pdf.text(`à ${birthPlace}`, 20, 49);
    pdf.text(`demeurant à ${address}, ${city}`, 20, 59);
    pdf.text(`Adresse mail: ${email}\n`, 20, 68);
    pdf.text(`Téléphone: ${phone}`, 20, 77);
    pdf.text(text, 15, 79);
    pdf.text(`Fait à ${signatureCity}, le ${signatureDate}`, 20, 215);
    pdf.text(`Signature précédée de la mention "Lu et approuvé"`, 20, 225);
    pdf.text(`Nom et prénom: ${name}`, 20, 235);
    pdf.text(`Signature:`, 20, 245);
    pdf.text(`OCI EXPRESS\nFabrice SINDRAYE\n0692 67 66 23\ncontact@ociexpress.re\nSIRET : 942 012 956 00010`, 140, 257);
  
    const emptyRows = [
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
    ];
  
    autoTable(pdf, {
      startY: 165,
      margin: { left: 20 },
      head: [["Nom", "Prénom", "Date de naissance", "Lieu de naissance", "Date"]],
      body: emptyRows,
      theme: 'grid',
      styles: { fontSize: 10, lineColor: 'black', lineWidth: 0.2 },
      headStyles: { fillColor: [255, 255, 255], textColor: 'black' },
      columnStyles: {
        0: { cellWidth: 55 },
        1: { cellWidth: 55 },
        2: { cellWidth: 20 },
        3: { cellWidth: 20 },
        4: { cellWidth: 20 }
      }
    });
  
    const canvas = canvasRef.current;
    const signatureImage = canvas.toDataURL("image/png");
  
    if (signatureImage) {
      const imgWidth = 50;
      const imgHeight = 20;
      pdf.addImage(signatureImage, 'PNG', 30, pdf.internal.pageSize.height - 40, imgWidth, imgHeight);
    }
  
    // Pour télécharger directement le PDF :
    setDownload(true)
    if (download)
      pdf.save("procuration.pdf");
  
    const pdfData = pdf.output("datauristring");
    const base64Pdf = pdfData.split(',')[1];
    return base64Pdf;
  };
  
  // Envoi du formulaire et du PDF
  const sendEmail = async (pdfBase64, fileBase64) => {
    const data = {
      name: name,
      birthDate: birthDate,
      birthPlace: birthPlace,
      address: address,
      email: email,
      phone: phone,
      pdf: pdfBase64,
      file: fileBase64,
    };
  
    try {
      await fetch("https://script.google.com/macros/s/AKfycbwwjmSkBEm-88wMWNgeflR-cDHf4F_Gp4jm7JhZ-HgPPmoD1Zo2rvSJFFEtVyhVC77uoA/exec", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
        mode: "no-cors",
      });
    } catch (error) {
      console.error("Erreur lors de l'envoi :", error);
      alert("Erreur lors de l'envoi du formulaire.");
    }
  };
  
  // Gestion de la soumission du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true); // On affiche l'animation de chargement
  
    const pdfBase64 = handleSubmitPDF();
    if (!pdfBase64 || !file) {
      alert("Veuillez remplir tous les champs et joindre un fichier !");
      setIsLoading(false);
      return;
    }
  
    const reader = new FileReader();
    reader.onloadend = () => {
      const fileBase64 = reader.result.split(",")[1];
      sendEmail(pdfBase64, fileBase64).then(() => {
        setIsLoading(false);
        setShowDownloadPrompt(true); // On affiche la modale de confirmation
      });
    };
    reader.readAsDataURL(file);
  };
  
  // Handlers pour les champs individuels
  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  
  const handleBirthDateChange = (event) => {
    setBirthDate(event.target.value);
  };
  
  const handleBirthPlaceChange = (event) => {
    setBirthPlace(event.target.value);
  };
  
  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };
  
  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };
  
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  
  const handleSignatureCityChange = (event) => {
    setSignatureCity(event.target.value);
  };
  
  const handleSignatureDateChange = (event) => {
    setSignatureDate(event.target.value);
  };
  
  const handleCityChange = (event) => {
    setCity(event.target.value);
  };
  
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
  
    if (canvas && ctx) {
      ctx.lineWidth = 2;
      ctx.lineCap = "round";
      ctx.strokeStyle = "#000000";
    }
  }, []);
  
  return (
    <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
      <h1 className="text-3xl font-bold dark:text-white text-black">
        Veuillez remplir le formulaire ci-dessous pour effectuer votre procuration
      </h1>
      <div className="mx-auto max-w-2xl m-20">
        <div className="mt-5 p-4 relative z-10 bg-white border border-gray-200 rounded-xl sm:mt-10 md:p-10 dark:bg-neutral-900 dark:border-neutral-700">
          <form onSubmit={handleSubmit}>
            {/* Formulaire principal */}
            <div className="mb-4 sm:mb-8">
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">
                Je soussigné(e)
              </label>
              <input type="text" name="name" id="name" className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black" placeholder="Nom et Prénom du demandeur" value={name} onChange={handleNameChange} required/>
            </div>
  
            <div className="mb-4 sm:mb-8">
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">
                Date de naissance
              </label>
              <input type="text" name="birthDate" id="birthDate" className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black" placeholder="Entrez votre date de naissance" value={birthDate} onChange={handleBirthDateChange} required/>
            </div>
  
            <div className="mb-4 sm:mb-8">
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">
                E-mail
              </label>
              <input type="text" name="email" id="email" className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black" placeholder="Entrez votre adresse mail" value={email} onChange={handleEmailChange} required/>
            </div>
  
            <div className="mb-4 sm:mb-8">
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">
                Télèphone
              </label>
              <input type="text" name="phone" id="phone" className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black" placeholder="Entrez votre numéro de téléphone" value={phone} onChange={handlePhoneChange} required/>
            </div>
  
            <div className="mb-4 sm:mb-8">
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">
                Ville de naissance
              </label>
              <input type="text" value={birthPlace} onChange={handleBirthPlaceChange} className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black" placeholder="Entrez votre lieu de naissance" required/>
            </div>
  
            <div className="mb-4 sm:mb-8">
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">
                Adresse de résidence actuel
              </label>
              <input type="text" value={address} onChange={handleAddressChange} className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black" placeholder="Entrez votre adresse" required/>
            </div>
  
            <div className="mb-4 sm:mb-8">
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">
                Ville
              </label>
              <input type="text" value={city} onChange={handleCityChange} className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black" placeholder="Entrez votre ville" required/>
            </div>
  
            <div className="mb-4 sm:mb-8">
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">
                Pièce d'identité
              </label>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*,application/pdf"
                onChange={handleFileChange}
                style={{ display: 'none'}}
                className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
              />
              <button
                type="button"
                onClick={handleClickFileInput}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Importez votre pièce d'identité
              </button>
            </div>
  
            {/* Signature électronique */}
            <div className='mt-6 grid'>
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">Fait à ...</label>
              <input
                type="text"
                name="ville"
                onChange={handleSignatureCityChange}
                placeholder="Entrez le nom de la ville"
                className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black"
                required
              />
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">le...</label>
              <input
                type="text"
                name="dateSignature"
                onChange={handleSignatureDateChange}
                placeholder="Entrez la date d'aujourd'hui"
                className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 text-black"
                required
              />
              <label className="block mb-2 text-sm font-medium dark:text-white text-black">Signature</label>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <canvas
                  ref={canvasRef}
                  width={400}
                  height={100}
                  className={`canvas-container ${isExpanded ? 'expanded' : ''}`}
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleMouseUp}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                  style={{
                    border: "1px solid black",
                    background: "white",
                    width: "100%",
                    height: isExpanded ? "70vh" : "100px",
                    maxWidth: "100%",
                    touchAction: "none",
                    transition: "all 0.3s ease",
                  }}
                >Signez</canvas>
              </div>
              {!isExpanded && (
                <button
                  type="button"
                  onClick={expandCanvas}
                  className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-900 focus:outline-none"
                >
                  Agrandir la zone de signature
                </button>
              )}
  
              {isExpanded && (
                <button
                  type="button"
                  onClick={collapseCanvas}
                  className="w-full mt-4 py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-600 text-white hover:bg-gray-800 focus:outline-none"
                >
                  Quitter le mode grand écran
                </button>
              )}
              <div className="flex mt-6">
                <input type="checkbox" className="shrink-0 mt-0.5 border-gray-200 rounded-sm text-blue-600 focus:ring-blue-500 checked:border-blue-500" id="hs-default-checkbox" required/>
                <label htmlFor="hs-default-checkbox" className="font-bold text-base text-gray-500 ms-3">Je reconnais avoir lu et approuvé le contenu de cette procuration</label>
              </div>
              <div className="mt-4">
                <button type="button" onClick={clearSignature} className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-red-600 text-white hover:bg-red-700 focus:outline-none">
                  Effacer la signature
                </button>
              </div>
            </div>
  
            {/* Bouton de soumission */}
            <div className="mt-6 grid">
              <button type="submit" className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none">
                Soumettre
              </button>
            </div>
          </form>
        </div>
      </div>
  
      {/* Modale de chargement avec animation */}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="dark:bg-black bg-white p-6 rounded-lg shadow-lg text-center flex flex-col items-center">
            <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="mt-4 text-lg font-medium dark:text-white text-black">Envoi en cours... <br></br> Veuillez patientez s'il vous plait</p>
          </div>
        </div>
      )}
  
      {/* Modale de confirmation */}
      {showDownloadPrompt && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="dark:bg-gray-800 p-6 rounded-lg shadow-lg text-center max-w-sm bg-white">
            <p className="text-lg font-medium mb-4 dark:text-white text-black">Le PDF a été envoyé avec succès.</p>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => {
                  handleSubmitPDF(); // Génère et télécharge le PDF
                  setShowDownloadPrompt(false);
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Télécharger le PDF
              </button>
              <button
                onClick={() => setShowDownloadPrompt(false)}
                className="px-4 py-2 border border-gray-400 text-gray-700 rounded hover:bg-gray-200"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Procuration;
